<template>
  <div class="mt-4">
    <FullScreenModal ref="base" name="downloadPdfModal" :centered="true" @show="onShow">
      <template #title>
        {{ nomeArquivo }}
      </template>
      <template #body>
        <div v-show="loadingPdf" class="row mx-md-n5 text-center">
          <div class="col py-3 px-md-5">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status" />
          </div>
        </div>
        <PDF
          v-if="pdfB64 != null && !loadingPdf"
          :pdf-width="'80%'"
          :row-gap="8"
          :src="pdfB64"
        />
      </template>
      <template #footer>
        <button type="button" class="btn btn-secondary" @click="$refs.base.hide()">
          <i class="bi bi-x" /> {{ $t("cancelar") }}
        </button>
        <LoadingButton class="btn-primary mw-120" :loading="downloading" @click="downloadPDF">
          <i class="bi bi-save" /> {{ $t("download") }}
        </LoadingButton>
      </template>
    </FullScreenModal>
  </div>
</template>

<script>
import FullScreenModal from '@/modules/core/components/FullScreenModal.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import PDF from 'pdf-vue3';
import { relatorio, blobToBase64 } from '../relatorioService';
export default {
  components: { FullScreenModal, LoadingButton, PDF },
  props: {
    params: { type: Object, required: true },
    nomeArquivo: { type: String, required: true },
  },
  data: () => ({
    pdfB64: null,
    pdfBlob: null,
    loadingPdf: false,
    downloading: false,
  }),
  methods: {
    onShow() { this.relatorio(); },
    show() { this.$refs.base.show(); },
    async relatorio() {
      this.loadingPdf = true;
      this.pdfBlob = await relatorio(this.params);
      this.pdfB64 = await blobToBase64(this.pdfBlob);
      this.loadingPdf = false;
    },
    async downloadPDF() {
      this.downloading = true;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(this.pdfBlob);
      link.download = this.nomeArquivo;
      link.click();
      URL.revokeObjectURL(link.href);
      await this.delay();
      this.downloading = false;
    },
    async delay() {
      return new Promise((resolve) => setTimeout(resolve, 1000));
    },
  },
};
</script>

<style scoped>
.mw-120 {
  min-width: 120px;
}
.pdf-vue3-canvas-container {
  width: 60%;
}
@media (max-width: 768px) {
  .pdf-vue3-canvas-container {
    width: 100%;
  }
}
</style>
